function Button(props) {
  return (
    <div className={`buttons`}>
      <button className={`buttons-contains`} type={props.type} onClick={props.onClick}>
        {props.contains}
      </button>
    </div>
  );
}

export default Button;
